"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SkeletonCard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _appConfigHelper = require("../../util/appConfigHelper");
var _planDetailsSlice = require("../../redux/planDetailsSlice");
var _MyAccountError = _interopRequireDefault(require("../MyAccountError"));
var _OfferMyAccountCard = _interopRequireDefault(require("../OfferMyAccountCard"));
var _OfferMyAccountCardLoader = _interopRequireDefault(require("../OfferMyAccountCard/OfferMyAccountCardLoader"));
var _SubscriptionManagement = _interopRequireDefault(require("../SubscriptionManagement"));
var _MessageBox = _interopRequireDefault(require("../MessageBox"));
var _MyAccountErrorStyled = require("../MyAccountError/MyAccountErrorStyled");
var _CurrentPlanStyled = require("./CurrentPlanStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-nested-ternary */
var NoSubscriptionsIcon = function NoSubscriptionsIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M77.763 43.205h-4.766a.762.762 0 0 1-.762-.762.762.762 0 0 1 .762-.762h4.766a1.382 1.382 0 0 0 1.381-1.38v-7.907a7.824 7.824 0 0 1-4.821-2.467 7.826 7.826 0 0 1-2.084-5.326 7.826 7.826 0 0 1 2.084-5.326 7.824 7.824 0 0 1 4.821-2.467V8.901a1.382 1.382 0 0 0-1.381-1.38H22.391a1.382 1.382 0 0 0-1.38 1.38v1.033a.762.762 0 0 1-.762.762.762.762 0 0 1-.762-.762V8.901a2.908 2.908 0 0 1 2.9-2.9h55.372a2.908 2.908 0 0 1 2.9 2.9v8.183a1.224 1.224 0 0 1-1.115 1.213 6.3 6.3 0 0 0-4.111 2.011 6.307 6.307 0 0 0-1.679 4.292 6.307 6.307 0 0 0 1.679 4.292 6.3 6.3 0 0 0 4.111 2.011 1.224 1.224 0 0 1 1.115 1.213v8.183a2.908 2.908 0 0 1-2.896 2.906Z",
                    fill: "#838eaa"
                  })
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M22.391 43.204a2.908 2.908 0 0 1-2.9-2.9v-8.181a1.223 1.223 0 0 1 1.12-1.214 6.3 6.3 0 0 0 4.129-2 6.3 6.3 0 0 0 1.688-4.3 6.3 6.3 0 0 0-1.688-4.3 6.3 6.3 0 0 0-4.129-2 .762.762 0 0 1-.7-.82.762.762 0 0 1 .82-.7 7.823 7.823 0 0 1 5.125 2.486 7.823 7.823 0 0 1 2.094 5.338 7.823 7.823 0 0 1-2.094 5.338 7.823 7.823 0 0 1-4.843 2.459v7.9a1.382 1.382 0 0 0 1.38 1.38.762.762 0 0 1 .762.762.762.762 0 0 1-.764.752Z",
                    fill: "#838eaa"
                  })
                })
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M33.516 10.616a.762.762 0 0 1-.762-.762V7.003a.762.762 0 0 1 .762-.762.762.762 0 0 1 .762.762v2.851a.762.762 0 0 1-.762.762Z",
                  fill: "#838eaa"
                })
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M33.516 20.027a.762.762 0 0 1-.762-.762V14.66a.762.762 0 0 1 .762-.762.762.762 0 0 1 .762.762v4.605a.762.762 0 0 1-.762.762Z",
                  fill: "#838eaa"
                })
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M33.516 27.684a.762.762 0 0 1-.762-.762v-4.605a.762.762 0 0 1 .762-.762.762.762 0 0 1 .762.762v4.605a.762.762 0 0 1-.762.762Z",
                  fill: "#838eaa"
                })
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M33.516 35.342a.762.762 0 0 1-.762-.762v-4.605a.762.762 0 0 1 .762-.762.762.762 0 0 1 .762.762v4.605a.762.762 0 0 1-.762.762Z",
                  fill: "#838eaa"
                })
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M33.516 42.999a.762.762 0 0 1-.762-.762v-4.605a.762.762 0 0 1 .762-.762.762.762 0 0 1 .762.762v4.605a.762.762 0 0 1-.762.762Z",
                  fill: "#838eaa"
                })
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M63.165 30.518a7.088 7.088 0 0 1 6.488-7.062.455.455 0 0 0 .417-.454v-8.183a2.142 2.142 0 0 0-2.143-2.142H12.555a2.142 2.142 0 0 0-2.142 2.142V23a.455.455 0 0 0 .418.454 7.088 7.088 0 0 1 6.518 7.065 7.088 7.088 0 0 1-6.518 7.065.455.455 0 0 0-.418.454v8.181a2.142 2.142 0 0 0 2.142 2.142h55.372a2.142 2.142 0 0 0 2.143-2.142v-8.184a.455.455 0 0 0-.417-.454 7.088 7.088 0 0 1-6.488-7.063Z",
                    fill: "#f2f5fc"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M67.927 49.122H12.553a2.907 2.907 0 0 1-2.9-2.9v-8.181a1.223 1.223 0 0 1 1.12-1.214 6.3 6.3 0 0 0 4.129-2 6.3 6.3 0 0 0 1.688-4.3 6.3 6.3 0 0 0-1.688-4.3 6.3 6.3 0 0 0-4.129-2 1.223 1.223 0 0 1-1.12-1.214v-8.181a2.907 2.907 0 0 1 2.9-2.9h55.372a2.907 2.907 0 0 1 2.9 2.9v8.183a1.224 1.224 0 0 1-1.115 1.213 6.3 6.3 0 0 0-4.111 2.011 6.3 6.3 0 0 0-1.679 4.292 6.3 6.3 0 0 0 1.679 4.292 6.3 6.3 0 0 0 4.111 2.011 1.224 1.224 0 0 1 1.115 1.213v8.183a2.907 2.907 0 0 1-2.898 2.892ZM11.174 38.31v7.9a1.382 1.382 0 0 0 1.381 1.38h55.372a1.382 1.382 0 0 0 1.38-1.38v-7.9a7.823 7.823 0 0 1-4.821-2.467 7.825 7.825 0 0 1-2.084-5.326 7.825 7.825 0 0 1 2.084-5.326 7.823 7.823 0 0 1 4.821-2.467v-7.907a1.382 1.382 0 0 0-1.38-1.38H12.553a1.382 1.382 0 0 0-1.381 1.38v7.9a7.823 7.823 0 0 1 4.842 2.459 7.824 7.824 0 0 1 2.094 5.338 7.824 7.824 0 0 1-2.094 5.338 7.823 7.823 0 0 1-4.84 2.458Zm58.415.025Z",
                    fill: "#838eaa"
                  })
                })]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  fill: "#fff",
                  d: "M23.68 12.92v4.605"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M23.68 18.287a.762.762 0 0 1-.762-.762V12.92a.762.762 0 0 1 .762-.762.762.762 0 0 1 .762.762v4.605a.762.762 0 0 1-.762.762Z",
                  fill: "#838eaa"
                })
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  fill: "#fff",
                  d: "M23.68 20.577v4.605"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M23.68 25.944a.762.762 0 0 1-.762-.762v-4.605a.762.762 0 0 1 .762-.762.762.762 0 0 1 .762.762v4.605a.762.762 0 0 1-.762.762Z",
                  fill: "#838eaa"
                })
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  fill: "#fff",
                  d: "M23.68 28.234v4.605"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M23.68 33.601a.762.762 0 0 1-.762-.762v-4.605a.762.762 0 0 1 .762-.762.762.762 0 0 1 .762.762v4.605a.762.762 0 0 1-.762.762Z",
                  fill: "#838eaa"
                })
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  fill: "#fff",
                  d: "M23.68 35.892v4.605"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M23.68 41.259a.762.762 0 0 1-.762-.762v-4.605a.762.762 0 0 1 .762-.762.762.762 0 0 1 .762.762v4.605a.762.762 0 0 1-.762.762Z",
                  fill: "#838eaa"
                })
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  fill: "#fff",
                  d: "M23.68 43.549v4.605"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M23.68 48.916a.762.762 0 0 1-.762-.762v-4.605a.762.762 0 0 1 .762-.762.762.762 0 0 1 .762.762v4.605a.762.762 0 0 1-.762.762Z",
                  fill: "#838eaa"
                })
              })]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M52.719 38.344a.762.762 0 0 1-.722-.52 8.177 8.177 0 0 0-7.76-5.577 8.179 8.179 0 0 0-7.756 5.564.762.762 0 0 1-.966.478.762.762 0 0 1-.478-.966 9.7 9.7 0 0 1 9.2-6.6 9.7 9.7 0 0 1 9.2 6.616.762.762 0 0 1-.48.965.759.759 0 0 1-.238.04Z",
                  fill: "#838eaa"
                })
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  transform: "translate(34.663 23.453)",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                    cx: "2.039",
                    cy: "2.039",
                    r: "2.039",
                    fill: "#838eaa"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M36.704 27.559a2.069 2.069 0 0 1-2.067-2.067 2.069 2.069 0 0 1 2.067-2.067 2.069 2.069 0 0 1 2.067 2.067 2.069 2.069 0 0 1-2.067 2.067Zm0-4.078a2.013 2.013 0 0 0-2.011 2.011 2.013 2.013 0 0 0 2.011 2.011 2.013 2.013 0 0 0 2.011-2.011 2.013 2.013 0 0 0-2.011-2.011Z",
                    fill: "#838eaa"
                  })
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  transform: "translate(49.738 23.453)",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                    cx: "2.039",
                    cy: "2.039",
                    r: "2.039",
                    fill: "#838eaa"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M51.776 27.559a2.069 2.069 0 0 1-2.067-2.067 2.069 2.069 0 0 1 2.067-2.067 2.069 2.069 0 0 1 2.066 2.067 2.069 2.069 0 0 1-2.066 2.067Zm0-4.078a2.014 2.014 0 0 0-2.012 2.011 2.014 2.014 0 0 0 2.012 2.011 2.013 2.013 0 0 0 2.011-2.011 2.013 2.013 0 0 0-2.011-2.011Z",
                    fill: "#838eaa"
                  })
                })]
              })]
            })]
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M81.701 51.579h-1.572a.762.762 0 0 1-.762-.762.762.762 0 0 1 .762-.762h1.572a.762.762 0 0 1 .762.762.762.762 0 0 1-.762.762Z",
              fill: "#838eaa"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M88.009 51.579h-1.572a.762.762 0 0 1-.762-.762.762.762 0 0 1 .762-.762h1.572a.762.762 0 0 1 .762.762.762.762 0 0 1-.762.762Z",
              fill: "#838eaa"
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M84.069 49.211a.761.761 0 0 1-.762-.762v-1.572a.761.761 0 0 1 .762-.762.762.762 0 0 1 .762.762v1.572a.762.762 0 0 1-.762.762Z",
              fill: "#838eaa"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M84.069 55.52a.761.761 0 0 1-.762-.762v-1.572a.761.761 0 0 1 .762-.762.762.762 0 0 1 .762.762v1.572a.762.762 0 0 1-.762.762Z",
              fill: "#838eaa"
            })
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M2.334 5.462H.762A.762.762 0 0 1 0 4.7a.762.762 0 0 1 .762-.762h1.572a.762.762 0 0 1 .762.762.762.762 0 0 1-.762.762Z",
              fill: "#838eaa"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M8.642 5.462H7.07a.762.762 0 0 1-.762-.762.762.762 0 0 1 .762-.762h1.572a.762.762 0 0 1 .762.762.762.762 0 0 1-.762.762Z",
              fill: "#838eaa"
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M4.701 3.096a.762.762 0 0 1-.762-.762V.762A.762.762 0 0 1 4.701 0a.762.762 0 0 1 .762.762v1.572a.762.762 0 0 1-.762.762Z",
              fill: "#838eaa"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M4.701 9.404a.762.762 0 0 1-.762-.762V7.07a.762.762 0 0 1 .762-.762.762.762 0 0 1 .762.762v1.572a.762.762 0 0 1-.762.762Z",
              fill: "#838eaa"
            })
          })]
        })]
      })]
    })
  });
};
NoSubscriptionsIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "88.77",
  height: "55.519"
};
const SkeletonCard = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CurrentPlanStyled.SubscriptionStyled, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferMyAccountCardLoader.default, {})
  });
};
exports.SkeletonCard = SkeletonCard;
const ErrorView = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CurrentPlanStyled.WrapStyled, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountError.default, {
      generalError: true
    })
  });
};
const EmptyPlanView = () => {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CurrentPlanStyled.WrapStyled, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_MyAccountErrorStyled.WrapStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountErrorStyled.IconStyled, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(NoSubscriptionsIcon, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountErrorStyled.TitleStyled, {
        children: t('currentplan.no-offers-title', 'No offers yet!')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountErrorStyled.SubTitleStyled, {
        children: (0, _appConfigHelper.getData)('CLEENG_OFFER_SELECTION_URL') ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactI18next.Trans, {
          i18nKey: "currentplan.no-offers-text-withlink",
          children: ["If you", ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
            href: (0, _appConfigHelper.getData)('CLEENG_OFFER_SELECTION_URL'),
            target: "_blank",
            rel: "noreferrer",
            children: "choose your plan"
          }), ", you will be able to manage your offers here."]
        }) : t('currentplan.no-offers-text', 'If you choose your plan, you will be able to manage your offers here.')
      })]
    })
  });
};
const CurrentPlan = () => {
  const [isMessageBoxOpened, setIsMessageBoxOpened] = (0, _react.useState)(false);
  const [messageBoxType, setMessageBoxType] = (0, _react.useState)(null);
  const [messageBoxText, setMessageBoxText] = (0, _react.useState)('');
  const [messageSubscriptionId, setMessageSubscriptionId] = (0, _react.useState)(null);
  const {
    data: subscriptions,
    loading: isLoading,
    error: errors
  } = (0, _reactRedux.useSelector)(state => state.plan.currentPlan);
  const {
    offerToSwitch
  } = (0, _reactRedux.useSelector)(state => state.plan);
  const dispatch = (0, _reactRedux.useDispatch)();
  const showMessageBox = (type, text, subscriptionId) => {
    setIsMessageBoxOpened(true);
    setMessageBoxType(type);
    setMessageBoxText(text);
    setMessageSubscriptionId(subscriptionId);
  };
  if (isLoading) return /*#__PURE__*/(0, _jsxRuntime.jsx)(SkeletonCard, {});
  if (errors !== null && errors !== void 0 && errors.length) return /*#__PURE__*/(0, _jsxRuntime.jsx)(ErrorView, {});
  if (subscriptions.length === 0) return /*#__PURE__*/(0, _jsxRuntime.jsx)(EmptyPlanView, {});
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CurrentPlanStyled.WrapStyled, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: subscriptions.map(subItem => {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CurrentPlanStyled.SubscriptionStyled, {
          as: "article",
          onClick: () => {
            if (subscriptions.length > 1 && subItem.offerType === 'S' && subItem.status === 'active') dispatch((0, _planDetailsSlice.setOfferToSwitch)(subItem));
          },
          cursorPointer: subscriptions.length > 1 && subItem.status === 'active' && subItem.offerType === 'S',
          isSelected: subscriptions.length > 1 && offerToSwitch.offerId === subItem.offerId,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferMyAccountCard.default, {
            offerId: subItem.offerId
          }), isMessageBoxOpened && messageSubscriptionId === subItem.subscriptionId && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CurrentPlanStyled.StatusMessageWrapStyled, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageBox.default, {
              type: messageBoxType,
              message: messageBoxText
            })
          }), subItem.offerType === 'S' && !subItem.isExternallyManaged && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionManagement.default, {
            subscription: subItem,
            showMessageBox: showMessageBox
          })]
        }, subItem.offerId);
      })
    })
  });
};
var _default = exports.default = CurrentPlan;